var React = require('react');

function Timeline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(.75)","fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#FFF","cx":"14.75","cy":"15.571","r":"5.5","key":0}),React.createElement("path",{"stroke":"#FFF","strokeLinecap":"square","d":"M.67.5h28.16M.67 15.571h28.16","key":1})]));
}

Timeline.defaultProps = {"width":"31","height":"22"};

module.exports = Timeline;

Timeline.default = Timeline;
